
function initTrip(){
    var Trip = window.Trip;
    var options = {
        showNavigation : true,
        showCloseBox : true,
        delay : -1,
        finishLabel: "Fertig",
        nextLabel: "weiter",
        prevLabel: "zurück",
        skipLabel: "überspringen",
        onTripChange: function(tripIndex, tripObject){
            var abc = tripObject
            var prev = this.tripData[tripIndex-1]
            if(prev != undefined){
                $(prev.sel).css("box-shadow", "none")
            }
            $(abc.sel).css("transition","box-shadow 0.3s ease-in-out");
            $(abc.sel).css("box-shadow", "rgba(0,0,0,0.5) 3px 1px 10px 1px")
        },
        onTripEnd: function(tripIndex, tripObject){
            var abc = tripObject
            $(abc.sel).css("box-shadow", "none")
        }
    }; 
    
    setTimeout(function(){
        var trip = new Trip([
  { 
    sel : $('#1'),
    content : 'Hier kannst du zwischen den Seiten navigieren',
     position : "s"
  },
  { 
    sel : $('#2'),
    content : 'Hier siehst du die Positionen der aktuellen Seite',
     position : "s"
  },
  {
      sel: $(".ac-job:first"),
      content: "Das ist eine Position",
      position: "s"
  }
], options);

  var config = new PTConfigManager();
  
  if(config.get("introShowed") == null && !window.mobilecheck()){
      trip.start()
      config.set("introShowed", true)
  }
    },2000)

}